module.exports = __webpack_public_path__ + "img/DE00680.618ef71d.png";